<template>
  <div class="d-flex align-center justify-center mt-2 mb-6">
    <v-textarea
      @input="$emit('input', $event)"
      :value="value"
      :label="label"
      :placeholder="placeholder"
      :outlined="outlined"
      :rows="rows"
      :disabled="loading"
      :hide-details="!hasError"
      :error-messages="errorMessage"
      class="flex-grow-1 px-1"
      dense
    ></v-textarea>

    <v-btn
      @click="$emit('regenerate')"
      :loading="loading"
      :disabled="disabled || loading"
      :elevation="0"
      :class="{'mb-5': hasError}"
      color="primary"
      fab
      x-small
    >
      <v-icon>{{ buttonIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'StoryboardInstruction',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonIcon: {
      type: String,
      default: 'mdi-refresh'
    },
    status: {
      type: String,
      default: ''
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasError() {
      return this.status.toLowerCase().includes('erro')
    },

    errorMessage() {
      return this.hasError ? this.$t('aiwf_sb_form_error_instruction') : ''
    }
  },

  emits: ['input', 'regenerate']
}
</script>
